var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailViewClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2071 5.29289C19.5976 5.68342 19.5976 6.31658 19.2071 6.70711L7.20711 18.7071C6.81658 19.0976 6.18342 19.0976 5.79289 18.7071C5.40237 18.3166 5.40237 17.6834 5.79289 17.2929L17.7929 5.29289C18.1834 4.90237 18.8166 4.90237 19.2071 5.29289Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79289 5.29289C6.18342 4.90237 6.81658 4.90237 7.20711 5.29289L19.2071 17.2929C19.5976 17.6834 19.5976 18.3166 19.2071 18.7071C18.8166 19.0976 18.1834 19.0976 17.7929 18.7071L5.79289 6.70711C5.40237 6.31658 5.40237 5.68342 5.79289 5.29289Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailViewClose);
export default __webpack_public_path__ + "static/media/detailViewClose.0bed9967d1d457f614e390ad4dc4b3b2.svg";
export { ForwardRef as ReactComponent };